import { render, staticRenderFns } from "./standard-unit-add.vue?vue&type=template&id=684bd387&scoped=true"
import script from "./standard-unit-add.vue?vue&type=script&lang=js"
export * from "./standard-unit-add.vue?vue&type=script&lang=js"
import style0 from "./standard-unit-add.vue?vue&type=style&index=0&id=684bd387&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684bd387",
  null
  
)

export default component.exports